import { Injectable } from '@angular/core';
import { SharedEventNameEnum } from '@smarttask-common/src/lib/models/AngularSpecific/SharedEventNameEnum';
import { RecordTypeEnum } from '@smarttask-common/src/lib/models/Record/Main/Enums/RecordTypeEnum';
import { OrganizationHubBase } from './organizationHubBase';

@Injectable({
    providedIn: 'root',
})
export class RecordHubService extends OrganizationHubBase {
    protected subscribe_event = SharedEventNameEnum.record_subscribe;
    protected unsubscribe_event = SharedEventNameEnum.record_unsubscribe;

    constructor() {
        super();
        this.init();
    }

    protected registerHandlers = () => {
        this.on(SharedEventNameEnum.record_new, (record_id: string, project_id: string, user_id: number) => {
            this.broadcast(SharedEventNameEnum.record_new, { record_id, project_id, user_id });
        });

        this.on(SharedEventNameEnum.record_update, (record_type: RecordTypeEnum, record_id: string) => {
            this.broadcast(SharedEventNameEnum.record_update, { record_type, record_id });
        });

        this.on(SharedEventNameEnum.record_update_multiple, (record_type: RecordTypeEnum, record_ids: string[]) => {
            this.broadcast(SharedEventNameEnum.record_update_multiple, { record_type, record_ids });
        });

        this.on(SharedEventNameEnum.record_delete, (record_type: RecordTypeEnum, record_id: string) => {
            this.broadcast(SharedEventNameEnum.record_delete, { record_type, record_id });
        });

        this.on(SharedEventNameEnum.record_activity_new, (record_type: RecordTypeEnum, record_id: string, activity_id: string) => {
            this.broadcast(SharedEventNameEnum.record_activity_new, { record_type, record_id, activity_id });
        });

        this.on(SharedEventNameEnum.record_activity_update, (record_type: RecordTypeEnum, record_id: string, activity_id: string) => {
            this.broadcast(SharedEventNameEnum.record_activity_update, { record_type, record_id, activity_id });
        });

        this.on(SharedEventNameEnum.record_activity_delete, (record_type: RecordTypeEnum, record_id: string, activity_id: string) => {
            this.broadcast(SharedEventNameEnum.record_activity_delete, { record_type, record_id, activity_id });
        });

        //In timeTracking Service
        this.on(SharedEventNameEnum.record_estimate_update, (record_id: string, estimated_time: number) => {
            this.broadcast(SharedEventNameEnum.record_estimate_update, { record_id, estimated_time });
        });

        this.on(SharedEventNameEnum.record_billable_update, (record_id: string, billable: boolean) => {
            this.broadcast(SharedEventNameEnum.record_billable_update, { record_id, billable });
        });

        this.on(SharedEventNameEnum.record_timelog_upsert, (record_id: string, actual_time: number, timelog_id: string) => {
            this.broadcast(SharedEventNameEnum.record_timelog_upsert, { record_id, actual_time, timelog_id });
        });

        //In ExtJiraIssueService
        this.on(SharedEventNameEnum.record_jira_sync, (record_id: string) => {
            this.broadcast(SharedEventNameEnum.record_jira_sync, { record_id });
        });
    };
}
